import { useQuery } from "@tanstack/react-query";
import { getStoreAuditSummariesWithOverallTotals } from "services/auditService";
import { StoreAuditSummaryRangeModel } from "models";

export interface StoreAuditSummaryRangeRequest {
  storeId: string;
  startDate: string;
  endDate: string;
}

export const useAuditDashboardStoreAuditSummaries = (
  params: StoreAuditSummaryRangeRequest | null | undefined
) => {
  return useQuery<StoreAuditSummaryRangeModel>({
    queryKey: [
      "audit-dashboard",
      "store-audit-summary-range",
      params?.storeId,
      params?.startDate,
      params?.endDate,
    ],
    queryFn: async () => {
      const response = await getStoreAuditSummariesWithOverallTotals(
        params!.storeId,
        params!.startDate,
        params!.endDate
      );

      return StoreAuditSummaryRangeModel.fromServerData({
        ...response,
        storeId: response?.storeId ?? params!.storeId,
        startDate: response?.startDate ?? params!.startDate,
        endDate: response?.endDate ?? params!.endDate,
      });
    },
    enabled: Boolean(params?.storeId && params?.startDate && params?.endDate),
  });
};
